<template>
  <div class="benefit-type-list-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-row class="align-items-center flex-nowrap">
          <!-- Filter dropdown -->
          <b-col cols="auto" class="pr-2">
            <b-dropdown
              id="dropdown-right dropdown-form"
              class="dropdown-form-filter"
              no-caret
              right
            >
              <template #button-content>
                <span class="svg-icon">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Bộ lọc
              </template>
              <h6 class="d-flex align-items-center mb-0 p-4">
                <span class="svg-icon mr-3">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Bộ lọc
              </h6>
              <b-dropdown-divider />
              <b-dropdown-form>
                <b-container class="p-0">
                  <b-row class="mb-3">
                    <b-col cols="6">
                      <basic-input
                        label="Tiêu đề"
                        placeholder="Nhập tiêu đề ưu đãi"
                        name="title"
                        :value.sync="filter.title"
                      />
                    </b-col>
                    <b-col cols="6">
                      <basic-select
                        label="Loại nội dung"
                        placeholder="Chọn loại nội dung"
                        name="contentType"
                        :options="contentTypeOptions"
                        track-by="value"
                        value-label="text"
                        :value.sync="filter.contentType"
                      />
                    </b-col>
                    <b-col cols="6">
                      <basic-select
                        label="Trạng thái"
                        placeholder="Chọn trạng thái"
                        name="status"
                        :options="statusOptions"
                        track-by="value"
                        value-label="text"
                        :value.sync="filter.status"
                      />
                    </b-col>
                    <b-col cols="6">
                      <basic-select
                        label="Voucher"
                        placeholder="Tất cả"
                        name="hasVoucher"
                        :options="voucherOptions"
                        track-by="value"
                        value-label="text"
                        :value.sync="filter.hasVoucher"
                      />
                    </b-col>
                  </b-row>
                </b-container>
              </b-dropdown-form>
              <b-dropdown-divider />
              <div class="d-flex align-items-center justify-content-lg-end m-0 p-4">
                <b-button class="btn ml-2" @click="resetRequest">
                  <span class="svg-icon">
                    <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
                  </span>
                  Reset bộ lọc
                </b-button>
                <b-button class="btn ml-2" @click="searchRequest">
                  <span class="svg-icon">
                    <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                  </span>
                  Lọc dữ liệu
                </b-button>
              </div>
            </b-dropdown>
          </b-col>

          <!-- Create button -->
          <b-col cols="auto" class="pl-2">
            <b-button class="btn btn-success" @click="$router.push({ name: 'benefit_type_create' })">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
              </span>
              Thêm mới
            </b-button>
          </b-col>
        </b-row>
      </template>
    </basic-subheader>

    <b-overlay :show="loading">
      <b-container fluid class="benefit-type-list-page__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="column"
                  :data="data"
                  :paging="paging"
                  :tableAction="false"
                  :selectAction="false"
                  :searchAction="false"
                  @search="searchRequest"
                  @reset="resetRequest"
                  @sortBy="sortRequest"
                >
                  <template v-slot:body="{ item, index }">
                    <td>
                      {{ (paging.page - 1) * paging.pageSize + index + 1 }}
                    </td>
                    <td>{{ item.title }}</td>
                    <td class="text-center">
                      <span :class="contentTypeBadgeClass(item.contentType)" class="type-badge">
                        {{ contentTypeLabel(item.contentType) }}
                      </span>
                    </td>
                    <td class="text-center">
                      <div class="status" :class="item.status === 1 ? 'active' : 'inactive'">
                        {{ item.status === 1 ? 'Hoạt động' : 'Không hoạt động' }}
                      </div>
                    </td>
                    <td class="text-center">
                      <span v-if="item.hasVoucher === 1" class="badge badge-warning">Có voucher</span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td>
                      <template v-if="item.hasVoucher === 1">
                        <div class="font-weight-bold">{{ item.voucherCode || '—' }}</div>
                        <div v-if="item.voucherValue" class="text-muted small">{{ formatPrice(item.voucherValue) }} VNĐ</div>
                      </template>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td class="text-center">
                      <span v-if="item.validUntil">{{ formatDate(item.validUntil) }}</span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td class="text-center">{{ item.order }}</td>
                    <td>
                      <action-dropdown
                        :value="item"
                        :show_copy="false"
                        :show_edit="false"
                        :show_delete="false"
                        @view="editItem(item)"
                      >
                        <b-dropdown-text tag="div" class="navi-item cursor-pointer">
                          <a class="navi-link" :class="item.status === 1 ? 'text-danger' : 'text-success'" @click.stop="confirmToggleStatus(item)">
                            <span class="menu-icon svg-icon svg-icon-sm">
                              <inline-svg src="/media/svg/icons/Neolex/Basic/trash.svg" />
                            </span>
                            <span>{{ item.status === 1 ? 'Không hoạt động' : 'Hoạt động' }}</span>
                          </a>
                        </b-dropdown-text>
                      </action-dropdown>
                    </td>
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: 'BenefitType',
  data() {
    return {
      loading: false,
      data: [],
      filter: {
        title: null,
        contentType: null,
        status: null,
        hasVoucher: null,
      },
      contentTypeOptions: [
        { value: 1, text: 'Text' },
        { value: 2, text: 'Hình ảnh' },
        { value: 3, text: 'Video' },
      ],
      statusOptions: [
        { value: 1, text: 'Hoạt động' },
        { value: 0, text: 'Không hoạt động' },
      ],
      voucherOptions: [
        { value: 1, text: 'Có voucher' },
        { value: 0, text: 'Không voucher' },
      ],
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      sort: { by: 'order', order: 'asc' },
      column: [
        { key: 'stt',         label: 'STT',           sortable: false },
        { key: 'title',       label: 'Tiêu đề',       sortable: false },
        { key: 'contentType', label: 'Loại nội dung', sortable: false, class: 'text-center' },
        { key: 'status',      label: 'Trạng thái',    sortable: false, class: 'text-center' },
        { key: 'hasVoucher',  label: 'Voucher',       sortable: false, class: 'text-center' },
        { key: 'voucherCode', label: 'Mã / Giá trị',  sortable: false },
        { key: 'validUntil',  label: 'HSD',           sortable: false, class: 'text-center' },
        { key: 'order',       label: 'Thứ tự',        sortable: false, class: 'text-center' },
        { key: '',            label: '',              sortable: false },
      ],
    };
  },

  computed: {
    searchParams() {
      const params = new URLSearchParams();
      if (this.filter.title) params.append('title', this.filter.title);
      if (this.filter.contentType != null) {
        const v = this.filter.contentType;
        params.append('contentType', v && v.value != null ? v.value : v);
      }
      if (this.filter.status != null) {
        const v = this.filter.status;
        params.append('status', v && v.value != null ? v.value : v);
      }
      if (this.filter.hasVoucher != null) {
        const v = this.filter.hasVoucher;
        params.append('hasVoucher', v && v.value != null ? v.value : v);
      }
      params.append('page', this.paging.page);
      params.append('size', this.paging.pageSize);
      return params;
    },
  },

  watch: {
    'paging.page'()     { this.loadData(); },
    'paging.pageSize'() { this.paging.page = 1; this.loadData(); },
  },

  async created() {
    await this.loadData();
  },

  activated() {
    this.loadData();
  },

  methods: {
    searchRequest() {
      this.paging.page = 1;
      this.loadData();
      document.body.click();
    },

    resetRequest() {
      this.filter = { title: null, contentType: null, status: null, hasVoucher: null };
      this.paging.page = 1;
      this.loadData();
      document.body.click();
    },

    sortRequest(sortData) {
      this.sort = { by: sortData.column, order: sortData.order };
      this.loadData();
    },

    async loadData() {
      try {
        this.loading = true;
        const { data } = await this.$api.get('/BundleBenefitType', { params: this.searchParams });
        this.data = data.items || [];
        this.paging.total = data.total || 0;
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: 'Không thể tải danh sách ưu đãi' });
      } finally {
        this.loading = false;
      }
    },

    editItem(item) {
      this.$router.push({ name: 'benefit_type_edit', params: { id: item.id } });
    },

    async confirmToggleStatus(item) {
      const activating = item.status !== 1;
      const ok = await this.$swal({
        title: '',
        text: activating
          ? `Bạn có chắc muốn cho "${item.title}" hoạt động lại không?`
          : `Bạn có chắc muốn ngừng hoạt động "${item.title}" không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: { text: 'Hủy', value: false, visible: true, className: 'btn btn-secondary', closeModal: true },
          confirm: { text: activating ? 'Kích hoạt' : 'Ngừng hoạt động', value: true, visible: true, className: activating ? 'btn btn-success' : 'btn btn-danger', closeModal: true },
        },
      });
      if (!ok) return;
      try {
        const payload = {
          ...item,
          status: activating ? 1 : 0,
          validUntil: item.validUntil ? Math.floor(new Date(item.validUntil).getTime() / 1000) : null,
        };
        await this.$api.put(`/BundleBenefitType/${item.id}`, payload);
        this.$toastr.s({ title: 'Thành công!', msg: activating ? 'Đã kích hoạt lại ưu đãi' : 'Đã ngừng hoạt động ưu đãi' });
        this.loadData();
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi!', msg: 'Không thể đổi trạng thái ưu đãi' });
      }
    },

    contentTypeLabel(type) {
      return { 1: 'Text', 2: 'Hình ảnh', 3: 'Video' }[type] || 'Text';
    },

    contentTypeBadgeClass(type) {
      return { 1: 'badge-text', 2: 'badge-image', 3: 'badge-video' }[type] || 'badge-text';
    },

    formatPrice(val) {
      if (!val) return '';
      return new Intl.NumberFormat('vi-VN').format(val);
    },

    formatDate(val) {
      if (!val) return '';
      const ms = typeof val === 'number' && val < 1e10 ? val * 1000 : val;
      return this.$moment ? this.$moment(ms).format('D/M/YYYY') : new Date(ms).toLocaleDateString('vi-VN');
    },
  },
};
</script>

<style lang="scss" scoped>
.status {
  padding: 6px 16px;
  color: #fff;
  border-radius: 20px;
  text-align: center;
  display: inline-block;
  font-size: 0.85rem;

  &.active   { background: #21a567; }
  &.inactive { background: #ff5756; }
}

.type-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 600;
}
.badge-text  { background: #f0f3ff; color: #5b6bf8; }
.badge-image { background: #fff3e0; color: #f57c00; }
.badge-video { background: #fde8e8; color: #e53935; }

.dropdown-form-filter .dropdown-menu .container {
  width: 560px;
}
</style>
